import React from "react";

import { ROUTES } from "~/router/constants/routes";
import { icons } from "~/ui";
import { tw } from "~/utils";

const CONSENT_ACCESSIBLE_NAME =
  "I read and agree to the Patient Services Agreement and Terms of Use, and have had the opportunity to review the Privacy Policy, Notice of Privacy Practices, and Consumer Health Data Privacy Notice.";

type ConsentCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
};

export const ConsentCheckbox = ({
  checked,
  onChange,
  error,
}: ConsentCheckboxProps) => {
  const errorId = "privacy-consent-error";

  return (
    <div className="space-y-2">
      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          id="privacy-consent"
          aria-label={CONSENT_ACCESSIBLE_NAME}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          className={tw(
            "text-indigo focus:ring-indigo mt-1 h-4 w-4 rounded border-gray-300",
            error && "border-red-500",
          )}
        />
        <label
          htmlFor="privacy-consent"
          className="text-dark-blue-gray text-sm"
        >
          I read and agree to the{" "}
          <a
            href={ROUTES.patientAgreement}
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet font-medium hover:underline"
          >
            Patient Services Agreement
          </a>{" "}
          and{" "}
          <a
            href={ROUTES.termsOfUse}
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet font-medium hover:underline"
          >
            Terms of Use
          </a>
          , and have had the opportunity to review the{" "}
          <a
            href={ROUTES.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet font-medium hover:underline"
          >
            Privacy Policy
          </a>
          ,{" "}
          <a
            href={ROUTES.privacyPractices}
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet font-medium hover:underline"
          >
            Notice of Privacy Practices
          </a>
          , and{" "}
          <a
            href={ROUTES.consumerHealthData}
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet font-medium hover:underline"
          >
            Consumer Health Data Privacy Notice
          </a>
          .
        </label>
      </div>

      {error && (
        <p
          id={errorId}
          className="flex items-center gap-1 text-sm text-red-600"
        >
          <icons.outline.ExclamationCircleIcon className="size-4" />
          {error}
        </p>
      )}
    </div>
  );
};
